<template>
  <v-container>
    <h1>新維修單</h1>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-row>
        <v-col cols="12">
          <v-text-field
            v-model="data.clientName"
            :rules="[v => !!v || '名字必須填寫']"
            label="客戶名字"
            required
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-text-field
            v-model="data.phone"
            :rules="[v => !!v || '電話必須填寫']"
            label="電話"
            required
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <v-select
            v-model="data.site"
            :items="sites"
            :rules="[v => !!v || '建案必須填寫']"
            label="建案"
            required
          ></v-select>
        </v-col>
        <v-col cols="6">
          <v-select
            v-model="data.problemType"
            :items="problemTypes"
            :rules="[v => !!v || '問題類別必須填寫']"
            label="問題類別"
            required
          ></v-select>
        </v-col>
      </v-row>
      <v-row v-if="data.site === '樂嵩豐'">
        <v-col cols="12">
          <v-select
            v-model="data.address"
            :items="leaddress"
            :rules="[v => !!v || '地址必須填寫']"
            label="樂嵩豐地址"
            required
          ></v-select>
        </v-col>
      </v-row>
      <v-row v-if="data.site === '耀嵩豐'">
        <v-col cols="12">
          <v-select
            v-model="data.address"
            :items="yaoaddress"
            :rules="[v => !!v || '地址必須填寫']"
            label="耀嵩豐地址"
            required
          ></v-select>
        </v-col>
      </v-row>
      <v-row v-if="data.site !== '樂嵩豐' && data.site !== '耀嵩豐'">
        <v-col cols="12">
          <v-text-field
            v-model="data.address"
            :rules="[v => !!v || '地址必須填寫']"
            label="地址"
            required
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-textarea
            v-model="data.description"
            label="描述"
            value=""
            :rules="[v => !!v || '描述必須填寫']"
            hint="請描述你的問題"
          ></v-textarea>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-text-field
            v-model="data.email"
            :rules="[v => !!v || '電子郵件必須填寫']"
            label="電子郵件"
            required
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <image-uploader
            :debug="1"
            :maxWidth="512"
            :quality="0.7"
            :autoRotate="true"
            outputFormat="string"
            :preview="true"
            :className="[' file-button', { 'fileinput--loaded': hasImage }]"
            accept="image/*"
            doNotResize="['gif', 'svg']"
            @input="setImage"
          ></image-uploader>
          <div class="caption blue-grey--text">
            用手機可以利用拍照功能上傳維修照片
          </div>
        </v-col>
      </v-row>
      <!-- <v-row>
        <v-col>
          <button @click="recaptcha">Recaptcha</button>
        </v-col>
      </v-row> -->
      <v-row class="mt-4">
        <v-col>
          <v-btn
            color="blue-grey white--text"
            outlined
            class="mr-4"
            @click="reset"
          >
            重設表單
          </v-btn>

          <v-btn color="blue-grey white--text" @click="submitForm">
            送出
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
// @ is an alias to /src
import { repairsCollection, db } from "@/db";
import firebase from "firebase";

export default {
  name: "NewRepair",
  data: () => ({
    valid: true,
    sites: [
      "樂嵩豐",
      "耀嵩豐",
      "悅嵩豐",
      "松丰",
      "文川",
      "淨美墅",
      "世璽",
      "帝門",
      "自由鑫貴",
      "綠園市2",
      "綠園市1",
      "品美術",
      "觀美術",
      "大社官邸",
      "嵩豐臻寶",
      "狀元邸",
      "嵩之園",
      "千禧園",
      "三荷園",
      "東方伯爵"
    ],
    problemTypes: [
      "水電",
      "防水",
      "衛浴設備",
      "弱電",
      "磁磚",
      "廚具",
      "油漆",
      "木作",
      "其他"
    ],
    data: {
      id: "",
      site: "",
      phone: "",
      email: "",
      description: "",
      address: "",
      clientName: "",
      problemType: "",
      customerFilePath: "",
      customerImg: ""
    },
    hasImage: false,
    image: "",
    siteImageType: "",
    leaddress: [
      "華欣路99號大樓管理室",
      "華欣路99號1.2樓",
      "華欣路99號3樓之1",
      "華欣路99號3樓之2",
      "華欣路99號3樓之3",
      "華欣路99號3樓之5",
      "華欣路99號3樓之6",
      "華欣路99號3樓之7",
      "華欣路99號4樓之1",
      "華欣路99號4樓之2",
      "華欣路99號4樓之3",
      "華欣路99號4樓之5",
      "華欣路99號4樓之6",
      "華欣路99號4樓之7",
      "華欣路99號5樓之1",
      "華欣路99號5樓之2",
      "華欣路99號5樓之3",
      "華欣路99號5樓之5",
      "華欣路99號5樓之6",
      "華欣路99號5樓之7",
      "華欣路99號6樓之1",
      "華欣路99號6樓之2",
      "華欣路99號6樓之3",
      "華欣路99號6樓之5",
      "華欣路99號6樓之6",
      "華欣路99號6樓之7",
      "華欣路99號7樓之1",
      "華欣路99號7樓之2",
      "華欣路99號7樓之3",
      "華欣路99號7樓之5",
      "華欣路99號7樓之6",
      "華欣路99號7樓之7",
      "華欣路99號8樓之1",
      "華欣路99號8樓之2",
      "華欣路99號8樓之3",
      "華欣路99號8樓之5",
      "華欣路99號8樓之6",
      "華欣路99號8樓之7",
      "華欣路99號9樓之1",
      "華欣路99號9樓之2",
      "華欣路99號9樓之3",
      "華欣路99號9樓之5",
      "華欣路99號9樓之6",
      "華欣路99號9樓之7",
      "華欣路99號10樓之1",
      "華欣路99號10樓之2",
      "華欣路99號10樓之3",
      "華欣路99號10樓之5",
      "華欣路99號10樓之6",
      "華欣路99號10樓之7",
      "華欣路99號11樓之1",
      "華欣路99號11樓之2",
      "華欣路99號11樓之3",
      "華欣路99號11樓之5",
      "華欣路99號11樓之6",
      "華欣路99號11樓之7",
      "華欣路99號12樓之1",
      "華欣路99號12樓之2",
      "華欣路99號12樓之3",
      "華欣路99號12樓之5",
      "華欣路99號12樓之6",
      "華欣路99號12樓之7",
      "華欣路99號13樓之1",
      "華欣路99號13樓之2",
      "華欣路99號13樓之3",
      "華欣路99號13樓之5",
      "華欣路99號13樓之6",
      "華欣路99號13樓之7",
      "華欣路99號14樓之1",
      "華欣路99號14樓之2",
      "華欣路99號14樓之3",
      "華欣路99號14樓之5",
      "華欣路99號14樓之6",
      "華欣路99號14樓之7",
      "華欣路99號15樓之1",
      "華欣路99號15樓之3",
      "華欣路99號15樓之6"
    ],
    yaoaddress: [
      "博愛四路309號管理委員會",
      "博愛四路309號",
      "博愛四路309號2樓",
      "博愛四路309號3樓之1",
      "博愛四路309號3樓之2",
      "博愛四路309號3樓之3",
      "博愛四路309號3樓之5",
      "博愛四路309號3樓之6",
      "博愛四路309號3樓之7",
      "博愛四路309號4樓之1",
      "博愛四路309號4樓之2",
      "博愛四路309號4樓之3",
      "博愛四路309號4樓之5",
      "博愛四路309號4樓之6",
      "博愛四路309號4樓之7",
      "博愛四路309號5樓之1",
      "博愛四路309號5樓之2",
      "博愛四路309號5樓之3",
      "博愛四路309號5樓之5",
      "博愛四路309號5樓之6",
      "博愛四路309號5樓之7",
      "博愛四路309號6樓之1",
      "博愛四路309號6樓之2",
      "博愛四路309號6樓之3",
      "博愛四路309號6樓之5",
      "博愛四路309號6樓之6",
      "博愛四路309號6樓之7",
      "博愛四路309號7樓之1",
      "博愛四路309號7樓之2",
      "博愛四路309號7樓之3",
      "博愛四路309號7樓之5",
      "博愛四路309號7樓之6",
      "博愛四路309號7樓之7",
      "博愛四路309號8樓之1",
      "博愛四路309號8樓之2",
      "博愛四路309號8樓之3",
      "博愛四路309號8樓之5",
      "博愛四路309號8樓之6",
      "博愛四路309號8樓之7",
      "博愛四路309號9樓之1",
      "博愛四路309號9樓之2",
      "博愛四路309號9樓之3",
      "博愛四路309號9樓之5",
      "博愛四路309號9樓之6",
      "博愛四路309號9樓之7",
      "博愛四路309號10樓之1",
      "博愛四路309號10樓之2",
      "博愛四路309號10樓之3",
      "博愛四路309號10樓之5",
      "博愛四路309號10樓之6",
      "博愛四路309號10樓之7",
      "博愛四路309號11樓之1",
      "博愛四路309號11樓之2",
      "博愛四路309號11樓之3",
      "博愛四路309號11樓之5",
      "博愛四路309號11樓之6",
      "博愛四路309號11樓之7",
      "博愛四路309號12樓之1",
      "博愛四路309號12樓之2",
      "博愛四路309號12樓之3",
      "博愛四路309號12樓之5",
      "博愛四路309號12樓之6",
      "博愛四路309號12樓之7",
      "博愛四路309號13樓之1",
      "博愛四路309號13樓之2",
      "博愛四路309號13樓之3",
      "博愛四路309號13樓之5",
      "博愛四路309號13樓之6",
      "博愛四路309號13樓之7",
      "博愛四路309號14樓之1",
      "博愛四路309號14樓之2",
      "博愛四路309號14樓之3",
      "博愛四路309號14樓之5",
      "博愛四路309號14樓之6",
      "博愛四路309號14樓之7",
      "博愛四路309號15樓之1",
      "博愛四路309號15樓之2",
      "博愛四路309號15樓之3",
      "博愛四路309號15樓之5",
      "博愛四路309號15樓之6",
      "博愛四路309號15樓之7",
      "博愛四路309號16樓之1",
      "博愛四路309號16樓之2",
      "博愛四路309號16樓之3",
      "博愛四路309號16樓之5",
      "博愛四路309號16樓之6",
      "博愛四路309號16樓之7",
      "博愛四路309號17樓之1",
      "博愛四路309號17樓之2",
      "博愛四路309號17樓之3",
      "博愛四路309號17樓之5",
      "博愛四路309號17樓之6",
      "博愛四路309號17樓之7",
      "博愛四路309號18樓之1",
      "博愛四路309號18樓之2",
      "博愛四路309號18樓之3",
      "博愛四路309號18樓之5",
      "博愛四路309號18樓之6",
      "博愛四路309號18樓之7",
      "博愛四路309號19樓之1",
      "博愛四路309號19樓之2",
      "博愛四路309號19樓之3",
      "博愛四路309號19樓之5",
      "博愛四路309號19樓之6",
      "博愛四路309號19樓之7",
      "博愛四路309號20樓之1",
      "博愛四路309號20樓之2",
      "博愛四路309號20樓之3",
      "博愛四路309號20樓之5",
      "博愛四路309號20樓之6",
      "博愛四路309號20樓之7",
      "博愛四路309號21樓之1",
      "博愛四路309號21樓之2",
      "博愛四路309號21樓之3",
      "博愛四路309號21樓之5",
      "博愛四路309號21樓之6",
      "博愛四路309號21樓之7",
      "博愛四路309號22樓之1",
      "博愛四路309號22樓之2",
      "博愛四路309號22樓之3",
      "博愛四路309號22樓之5",
      "博愛四路309號22樓之6",
      "博愛四路309號22樓之7",
      "博愛四路309號23樓之1",
      "博愛四路309號23樓之2",
      "博愛四路309號23樓之3",
      "博愛四路309號23樓之5",
      "博愛四路309號23樓之6",
      "博愛四路309號23樓之7",
      "博愛四路309號24樓之1",
      "博愛四路309號24樓之2",
      "博愛四路309號24樓之3",
      "博愛四路309號24樓之5",
      "博愛四路309號24樓之6",
      "博愛四路309號24樓之7",
      "博愛四路309號25樓之1",
      "博愛四路309號25樓之2",
      "博愛四路309號25樓之3",
      "博愛四路309號25樓之5",
      "博愛四路309號25樓之6",
      "博愛四路309號25樓之7",
      "博愛四路309號26樓之1",
      "博愛四路309號26樓之2",
      "博愛四路309號26樓之3",
      "博愛四路309號26樓之5",
      "博愛四路309號26樓之6",
      "博愛四路309號26樓之7",
      "博愛四路309號27樓之1",
      "博愛四路309號27樓之2",
      "博愛四路309號27樓之3",
      "博愛四路309號27樓之5",
      "博愛四路309號28樓之1",
      "博愛四路309號28樓之2",
      "博愛四路309號28樓之3",
      "博愛四路309號28樓之5"
    ]
  }),
  created() {
    const vm = this;
    // repairsCollection.get().then(function(querySnapshot) {
    //   vm.data.id = querySnapshot.size + 1 + "";
    // });

    db.collection("basicInfo")
      .doc("0")
      .get()
      .then(doc => {
        if (doc.exists) {
          vm.data.id = "" + doc.data().totalCount++;
        } else {
          // doc.data() will be undefined in this case
          // eslint-disable-next-line no-console
          console.log("No such document!");
        }
      });
  },
  methods: {
    setImage: function(output) {
      this.hasImage = true;
      this.image = output;
      this.siteImageType = output.substring(5, output.indexOf(";base64"));
    },
    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    submitForm() {
      this.validate();
      if (this.hasImage == false) {
        this.addStoreData();
      } else {
        this.storeImgToFireStore().then(url => {
          this.data.customerImg = url.downloadURL;
          this.addStoreData();
        });
      }
    },
    addStoreData() {
      const newRepair = {
        address: this.data.address,
        clientName: this.data.clientName,
        completed: false,
        description: this.data.description,
        email: this.data.email,
        finishedCurrentUser: "",
        created_at: new Date(),
        finsihedDate: "",
        finsihedImage: "",
        phone: this.data.phone,
        problemType: this.data.problemType,
        site: this.data.site,
        customerFilePath: this.data.customerFilePath,
        customerImg: this.data.customerImg,
        repair_items: []
      };
      repairsCollection
        .doc(this.data.id)
        .set(newRepair)
        // eslint-disable-next-line no-unused-vars
        .then(docRef => {
          this.$swal("你的維修單已送出").then(() => {
            window.location.href = "http://www.songfeng.com.tw/";
          });
        })
        .catch(error => console.log(error));
    },
    storeImgToFireStore() {
      // eslint-disable-next-line
      const vm = this;
      // Folder Name
      const storageRef = firebase.storage().ref(`/${this.data.id}/`);
      const file = this.image.replace(`data:${this.siteImageType};base64,`, "");
      // 20190318
      const currentDate = new Date()
        .toISOString()
        .slice(0, 10)
        .replace(/-/g, "");

      const fileName = `${this.data.id}_${currentDate}_${Math.floor(
        Math.random() * 90000
      ) + 10000}_customer`;

      this.data.customerFilePath = fileName;
      return new Promise((resolve, reject) => {
        storageRef
          .child(fileName)
          .putString(file, "base64", { contentType: this.siteImageType })
          .then(snapshot => {
            snapshot.ref.getDownloadURL().then(function(downloadURL) {
              const data = { name, downloadURL };
              resolve(data);
            });
          })
          .catch(error => {
            console.log("One failed:", error);
            reject(error);
          });
      });
    }
    // recaptcha() {
    //   console.log("recaptcha clicked");
    //   this.$recaptchaLoaded().then(() => {
    //     console.log("recaptcha loaded");
    //     this.$recaptcha("login").then(token => {
    //       console.log(token); // Will print the token
    //     });
    //   });
    // }
  }
};
</script>
